import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogTitle, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';

/*Services*/
import { CrudService } from '@services/laravel/crud.service';
import { ValidateRequired } from '@shared/validators/required.validator';
import { ToastrService } from 'ngx-toastr';
import { MatFormField, MatInput, MatError } from '@angular/material/input';

import { MatButton } from '@angular/material/button';

@Component({
    standalone: true,
    selector: 'app-ntm-input-dialog',
    templateUrl: './input-dialog.component.html',
    styleUrls: ['./input-dialog.component.css'],
    imports: [MatDialogTitle, FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatError, MatDialogActions, MatButton, MatDialogClose]
})

export class InputDialogComponent implements OnInit {
  @Output()
  change: EventEmitter<string> = new EventEmitter<string>();

  public dataForm: UntypedFormGroup;
  dataToDelete: any;
  dialogMessage: string;
  constructor(
    public dialogRef: MatDialogRef<InputDialogComponent>,
    private crud: CrudService,
    private router: Router,
    private matsnackbar: MatSnackBar,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
    if (!this.data.dialogMessage) {
      this.dialogMessage = 'Tem certeza que deseja apagar?';
    } else {
      this.dialogMessage = this.data.dialogMessage;
    }

    this.dataForm = new UntypedFormGroup({
      'new_name': new UntypedFormControl(null, ValidateRequired),
    });
  }
  delete() {
    this.crud.delete(this.data.routeToApi + '/' + this.data.paramToDelete)
    .then(() => {
      this.router.navigate([this.data.routeAfterDelete]);

      const string = 'Item(ns) excluído(s) com sucesso.';

      // this.matsnackbar.open(string, '', {
      //   duration: 3000
      // });
      this.toastr.success(string, 'Sucesso!');
    });
    this.dialogRef.close(true);
  }

  continue() {
    this.dialogRef.close(this.dataForm.get('new_name').value);
  }
}
